<template>
    <div class="subscription-fqa-panel blue-block">
        <div class="panel-header">
            <h3 class="panel-title">Frequently asked questions</h3>
        </div>
        <div class="main-container">
          <div class="frequent-question-item flex-between-wrapper" :key="idx" v-for="(item, idx) in faqItems">
            <rt-picture class="icon-circle" src="/assets/app/class/icon-circle-yellow.svg"></rt-picture>
            <div class="item-info-wrapper">
              <h3 class="question-info" :class="{ expanded: item.expanded }" @click="handleClickDropdown(idx)">{{ item.question }}</h3>
              <p class="answer-info" v-html="item.answer" v-if="item.expanded"></p>
            </div>
            <primary-button class="btn-expand-item btn-normal" @click="handleClickDropdown(idx)">
              <rt-picture :src="itemButtonIcon(idx)"></rt-picture>
            </primary-button>
          </div>
        </div>
    </div>
</template>

<script>

import RtPicture from '../../common/Picture.vue';
import PrimaryButton from '../../common/PrimaryButton.vue';

export default {
  components: {
    RtPicture,
    PrimaryButton
  },
  props: ['faqItems'],
  methods: {
    itemButtonIcon(itemIndex) {
      if (!this.faqItems[itemIndex].expanded) {
        return '/assets/app/class/icon-arrow-down.svg';
      } else {
        return '/assets/app/class/icon-arrow-up.svg';
      }
    },
    handleClickDropdown(itemIndex) {
      const newFAQItems = [
        ...this.faqItems
      ];
      newFAQItems[itemIndex].expanded = !newFAQItems[itemIndex].expanded;
      this.faqItems = newFAQItems;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../common/variables';

.subscription-fqa-panel {
  padding: 128px 0;
  .panel-header {
    padding-bottom: 56px;
  }
  .main-container {
    max-width: 770px !important;
    .frequent-question-item {
      align-items: flex-start;
      background: #fff;
      padding: 0 32px 2px;
      margin-bottom: 16px;
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
      border-radius: 16px;
      position: relative;
      .icon-circle {
        position: absolute;
        left: 101px;
        top: -8px;
      }
      .item-info-wrapper {
        flex: 1;
        margin-right: 10px;
        .question-info {
          max-width: 90%;
          padding: 32px 0;
          font-family: $title-font;
          font-weight: 700;
          font-size: 18px;
          color: $title-dark-grey;
          cursor: pointer;
          &.expanded {
            padding-bottom: 16px;
          }
        }
        .answer-info {
          padding-bottom: 32px;
          font-size: 16px;
          color: $title-grey;
        }
      }
      .btn-expand-item {
        min-width: 14px;
        margin-top: 40px;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  @media (max-width: 767px) {
    padding: 50px 0;
  }
}
</style>
